import React from 'react';
import { Button } from '../ui/button';
import { pricingData } from '../../mockData';
import { trackPricingCtaClick } from '@/lib/analytics';

/**
 * Phase 5D — AUD-native pricing.
 * Prices are stored AS AUD in mockData.js. Multi-currency conversion happens
 * at checkout (AUD / USD / KES pills), so the marketing page no longer needs
 * to display USD→AUD approximations.
 */
const PricingSection = ({ selectedService, setSelectedService, scrollToBooking }) => {
  return (
    <section id="pricing" className="section-light">
      <div className="section-container">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="accent-bar"></div>
          <h2 className="heading-lg mb-6">Clear, Transparent Pricing</h2>
          <p className="body-lg mb-10" style={{ color: 'var(--text-grey)' }}>
            All prices in AUD. Pay in AUD, USD or KES at checkout — your card is
            charged in the currency you choose.
          </p>
          <div className="flex justify-center gap-4 mb-16 flex-wrap">
            <Button onClick={() => setSelectedService('ielts')} className={selectedService === 'ielts' ? 'btn-teal' : 'btn-secondary'} data-testid="pricing-tab-ielts">IELTS Coaching</Button>
            <Button onClick={() => setSelectedService('vce')} className={selectedService === 'vce' ? 'btn-teal' : 'btn-secondary'} data-testid="pricing-tab-vce">VCE Tutoring</Button>
            <Button onClick={() => setSelectedService('selective')} className={selectedService === 'selective' ? 'btn-teal' : 'btn-secondary'} data-testid="pricing-tab-selective">Selective Entry</Button>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto">
          {pricingData[selectedService].map((plan) => (
            <div key={plan.id} className={`pricing-card ${plan.popular ? 'popular' : ''}`} data-testid={`pricing-card-${selectedService}-${plan.id}`}>
              <h3 className="heading-md mb-3">{plan.name}</h3>
              <div className="mb-8">
                <div className="flex items-baseline gap-2 flex-wrap">
                  <span className="text-5xl font-bold" style={{ color: 'var(--primary-black)' }} data-testid={`pricing-price-${selectedService}-${plan.id}`}>
                    {plan.price}
                  </span>
                  <span style={{ color: 'var(--text-grey)' }} className="text-base">/ {plan.duration}</span>
                </div>
              </div>
              <ul className="space-y-5 mb-10">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-4">
                    <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: 'var(--accent-teal)' }}>
                      <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="body-md">{feature}</span>
                  </li>
                ))}
              </ul>
              <Button onClick={() => { trackPricingCtaClick(selectedService, plan.id); scrollToBooking(); }} className={plan.popular ? 'btn-gold w-full' : 'btn-primary w-full'} data-testid={`pricing-cta-${selectedService}-${plan.id}`}>
                {plan.cta}
              </Button>
            </div>
          ))}
        </div>
        <p className="text-center mt-10 italic" style={{ color: 'var(--text-grey)' }}>
          Group classes and writing feedback packages are also available. Contact us for details.
        </p>
      </div>
    </section>
  );
};

export default PricingSection;
